import { render, staticRenderFns } from "./short_video_detail_form.vue?vue&type=template&id=56491371"
import script from "./short_video_detail_form.vue?vue&type=script&lang=js"
export * from "./short_video_detail_form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports